import { KioskConfiguration } from "../models/kiosk-configuration";
import { httpClient } from "../../../service/http";
import { OrganizationKeyName } from "../../../model/Organization";

export const kioskConfigurationHttp = {
  getKioskConfigurations: async (organizationKeyName: OrganizationKeyName) => {
    const res = await httpClient<{ data: KioskConfiguration[] }>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/shop-self-service-configs`,
    });
    return res.data;
  },
};
